import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import {Ownership} from "../../models/ownership";
import Helpers from "../../utils/helpers";

@Injectable()
export class OwnershipControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public createOwnership(ownership: Ownership): Observable<Ownership> {
    Helpers.trimRecursiveObj(ownership);
    const body = JSON.stringify(ownership);
    return this.http.post(this.baseUrl + "ownership", body) as Observable<Ownership>;
  }

  public saveOwnership(ownership: Ownership) {
    Helpers.trimRecursiveObj(ownership);
    const body = JSON.stringify(ownership);
    return this.http.put(this.baseUrl + "ownership", body, { responseType: "text" });
  }
}
